const getColSpanClass = (colSpan: string) => {
	switch (colSpan) {
		case "col-span-1":
			return "col-span-1";
		case "col-span-2":
			return "col-span-2";
		case "col-span-3":
			return "col-span-3";
		case "col-span-4":
			return "col-span-4";
		case "col-span-5":
			return "col-span-5";
		case "col-span-6":
			return "col-span-6";
		default:
			return "";
	}
};

export default getColSpanClass;
